"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.amenitiesById = void 0;
const key_by_1 = require("../../helpers/key-by");
exports.amenitiesById = (state = {}, action = {}) => {
    switch (action.type) {
        case 'PROPERTY_GET_BY_ID_RECEIVE':
        case 'PROPERTY_PUBLISH_RECEIVE':
        case 'PROPERTY_CREATE_RECEIVE':
        case 'PROPERTY_UPDATE_RECEIVE':
            return Object.assign(Object.assign({}, state), key_by_1.keyEntitiesBy(action.payload.property.amenities, 'id'));
        case 'AMENITY_GET_BY_ID_RECEIVE':
        case 'AMENITY_CREATE_RECEIVE':
        case 'AMENITY_UPDATE_RECEIVE':
            return Object.assign(Object.assign({}, state), { [action.payload.amenity.id]: action.payload.amenity });
        case 'AMENITY_DELETE_RECEIVE':
            const _a = state, _b = action.payload.deleted, deleted = _a[_b], remaining = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
            return remaining;
        case 'PROPERTY_DELETE_SUBDOCUMENTS_RECEIVE':
            const deletedIds = (action.payload.subdocuments.amenities || []).map((a) => a.deleted);
            return Object.entries(state).reduce((final, curr) => {
                const [id, amenity] = curr;
                if (!deletedIds.includes(Number.parseInt(id, 10))) {
                    final[id] = amenity;
                }
                return final;
            }, {});
        case 'AMENITIES_BY_PROPERTY_RECEIVE':
            return Object.assign(Object.assign({}, state), key_by_1.keyEntitiesBy(action.payload, 'id'));
        case 'PROPERTIES_BY_OWNER_RECEIVE':
            const allAmenities = action.payload.properties.reduce((all, prop) => {
                return all.concat(prop.amenities || []);
            }, []);
            return Object.assign(Object.assign({}, state), key_by_1.keyEntitiesBy(allAmenities, 'id'));
        default:
            return state;
    }
};
//# sourceMappingURL=reducer.js.map